var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudConnectColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107 82.2",
    style: {
      enableBackground: "new 0 0 107 82.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2A6BB7;stroke:#2A6BB7;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:#60DE00;stroke:#60DE00;stroke-width:3;stroke-miterlimit:10;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud_connect_colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.5,44c0-11.3-9.6-20.5-21.5-20.5c-3.7,0-7.4,0.9-10.6,2.7c0.1-0.7,0.1-1.4,0.1-2.2 c0-12.4-10.1-22.5-22.6-22.4c-11.2,0-20.7,8.4-22.2,19.5c-5.5,1.7-9.2,6.7-9.2,12.4c0,0.3,0,0.7,0,1H19c-9.7,0-17.5,6.7-17.5,15 s7.8,15,17.5,15h0.5l0,0h65l0,0C96.1,64.2,105.5,55.2,105.5,44z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.8,38.5 66.2,33 47.8,64.8 28.9,53.9 23.2,63.6 51.9,80.2 57.5,70.4 57.4,70.3  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudConnectColored);
export default __webpack_public_path__ + "static/media/CloudConnectColored.71e7ac1adbbd89906eda93e92d972d13.svg";
export { ForwardRef as ReactComponent };